import React, {useEffect, useState} from "react";
import {LoggedInView} from "../common/LoggedInView";
import {useAppDispatch} from "../../utils/Hooks";
import {UsersTable} from "./components/UsersTable";
import {getUsers} from "../../store/reducers/UsersSlice";

interface UsersTableProps {
}

export const UsersScreen: React.FC<UsersTableProps> = () => {

    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(getUsers());
    }, []);

    return (
        <LoggedInView fullWidth={false}>
            <h1>Kasutajad</h1>
            <UsersTable />
        </LoggedInView>
    )

}